module.exports = __webpack_public_path__ + "img/shape-34.a83eaedc.svg";